import { useTranslation } from '@edreamsodigeo/frontend-core';
import { FC } from 'react';

type StopoverQuantityMessageProps = {
  quantity: number;
};

const StopoverQuantityMessage: FC<StopoverQuantityMessageProps> = ({
  quantity,
}) => {
  const isDirect = quantity === 0;
  const { t } = useTranslation();

  return t('results.segment.stops', {
    count: quantity,
    context: isDirect ? 'none' : 'some',
  });
};

export default StopoverQuantityMessage;
